// Try to keep imports and declarations here alphabetically ordered.
// This helps with diffs and readability.

import Vue from 'vue'
import MusashiLayout from '@app/MusashiLayout.vue'
import TextFilter from '@app/components/tables/TextFilter.vue'
import UeDraggable from '@components/base/UeDraggable.vue'
import UeEmptyState from '@components/base/UeEmptyState.vue'
import UeExportButton from '@components/base/UeExportButton.vue'
import UeMasonry from '@components/base/UeMasonry.vue'
import UeModal from '@components/base/UeModal.vue'
import UeNav from '@components/base/nav/UeNav.vue'
import UeNavItem from '@components/base/nav/UeNavItem.vue'
import UePagination from '@components/base/UePagination.vue'
import UeSelect from '@components/base/UeSelect.vue'
import UeTable from '@components/base/UeTable.vue'
import UeTimeline from '@components/base/UeTimeline.vue'
import UeSpinner from '@components/base/UeSpinner.vue'

export default {
  install() {
    Vue.component('MusashiLayout', MusashiLayout)
    Vue.component('UeDraggable', UeDraggable)
    Vue.component('UeEmptyState', UeEmptyState)
    Vue.component('UeExportButton', UeExportButton)
    Vue.component('UeMasonry', UeMasonry)
    Vue.component('UeModal', UeModal)
    Vue.component('UeNav', UeNav)
    Vue.component('UeNavItem', UeNavItem)
    Vue.component('UePagination', UePagination)
    Vue.component('UeSelect', UeSelect)
    Vue.component('UeTable', UeTable)
    Vue.component('UeTextFilter', TextFilter)
    Vue.component('UeTimeline', UeTimeline)
    Vue.component('UeSpinner', UeSpinner)
  },
}
